import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { usePermissions } from "@/rbac/usePermissions";
import { useAppDispatch, useAppSelector } from "@/stores/hook";
import { setIsAddCourse } from "../../stores/courseFunctionalSlice";
import AddCourse from "./addCourse";

/** Sidebar route key of the "Universities & Courses" module (server TAB_BACKEND_REGISTRY). */
const UNIVERSITIES_ROUTE_KEY = "universities";

/**
 * "Add a Course" from inside the lead drawer (deal Overview, Attach Course
 * modal). Opens the University & Course module's own AddCourse sheet, for
 * anyone whose role can open that module — same gate as the drawer's Course
 * tab pill (`hasRouteKey` bypasses for admins).
 *
 * The sheet's open flag is the shared redux `courseFunctional.isAddCourse`, and
 * this button renders once PER DEAL, so the sheet is mounted only by the
 * instance that was clicked — otherwise every deal would open its own copy.
 * Create invalidates `["courses"]`, so the attach list picks the course up.
 */
export default function AddCourseButton({
  className,
  label = "Add a Course",
}: {
  className?: string;
  label?: string;
}) {
  const dispatch = useAppDispatch();
  const { hasRouteKey } = usePermissions();
  const isAddCourse = useAppSelector(
    (state) => state.courseFunctional.isAddCourse,
  );
  const [mine, setMine] = useState(false);

  useEffect(() => {
    if (!isAddCourse) setMine(false);
  }, [isAddCourse]);

  if (!hasRouteKey(UNIVERSITIES_ROUTE_KEY)) return null;

  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setMine(true);
          dispatch(setIsAddCourse(true));
        }}
        className={className}
        title="Add a course to the University & Course module"
      >
        <Plus className="size-3" />
        {label}
      </button>
      {mine && isAddCourse && <AddCourse trigger={<></>} />}
    </>
  );
}
